import { Client, TablesDB, Account, ID, Storage, Teams, Functions, Query } from "appwrite";

const client = new Client();

export const DB_ID = "67a0b1a5003c64d95af1";

export const USERS_TABLE_ID = "67a0b1ae0008871264a5";
export const PROJECTS_TABLE_ID = "67a0c771001e17596b6c";
export const ADDRESSES_TABLE_ID = "67a0c779001f78a648fb";
export const PARK_INPUTS_TABLE_ID = "67ab70db0035e36b6bb6";

export const PUBLIC_BUCKET = "67a1a783000c939dfbad";
export const PRIVATE_BUCKET = "67a1a78d001613a5021e";

//functions Id
export const CHECK_USER_BY_PHONE_FUNCTION_ID = "67b8155300079c75e8dd";
export const SEND_FIRST_SMS_FUNCTION_ID = "67be8fdc0024cf0dab1c";
export const SEND_SECOND_SMS_FUNCTION_ID = "67be9e8b002255d40654";
export const DELETE_PROJECT_FUNCTION_ID = "67d833c4003045b06f8d";


client
    .setEndpoint('https://api.gengraphic.de/v1')
    .setProject('67a0af06003a2c2a92ed');

export const account = new Account(client);
export const db = new TablesDB(client);
export const storage = new Storage(client);
export const teams = new Teams(client);
export const functions = new Functions(client);
export const query = Query;
export const id = ID;
